<template lang="pug">
  .input-list
    transition-group(name="slide-fade")
      .input-container.list(v-for="(data, index) in dataForm[property]" :key="id[index]")
        label.label
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" :property="property" :title="title" :index="index")

        input.input(v-model.number="dataForm[property][index]" @input="addInput(dataForm[property], index)" type="number" :pattern="pattern" :min="min" :max="max" :required="required >= 0 ? index + 1 <= required : false" :class="{'next-input-optional': (!data && data !== 0) && index !== 0}" autocomplete="ño")

        .delete-button.times-icon.mini-button(@click="discard(dataForm[property], index)" v-show="required >= 0 ? required < index + 1 : true && (dataForm[property].length - 1 !== index)")
</template>

<script>
import mForm from '@/mixins/form'
import mFilters from '@/mixins/filters'

export default {
  name: 'InputList',

  mixins: [mForm, mFilters],

  props: {
    dataForm: Object,
    property: String,
    pattern: String,
    title: String,
    dataOriginal: Object,
    fillData: Boolean,
    required: Number,
    min: Number,
    max: Number
  },

  data () {
    return {
      i: 0,
      id: [0]
    }
  },

  created () {
    this.initIdKeys()
    this.addInputIfUpdate()
  },

  methods: {
    initIdKeys () {
      if (Array.isArray(this.dataForm[this.property])) {
        this.i = this.dataForm[this.property].length || 0
        this.id = this.dataForm[this.property].map((_, index) => index)
      }
    },

    addInputIfUpdate (data = this.dataForm) {
      const array = data[this.property]
      const lastElement = array[array.length - 1]

      if ((this.fillData && lastElement) || (this.fillData && lastElement === undefined)) {
        this.pushEmpty(data[this.property])
      }
    }
  },

  watch: {
    dataForm: {
      handler (newVal, oldVal) {
        const diferenceLength = newVal[this.property].length - oldVal[this.property].length

        for (let i = 0; i < diferenceLength; i++) {
          this.id.push(this.i++)
        }
      },
      deep: true
    }
  }
}
</script>

<style lang="stylus">
.input-list
  width 100%
  position relative

.delete-button
  position absolute
  right 1.2em
  bottom 1.2em
</style>



// WEBPACK FOOTER //
// src/components/elements/InputListNumber.vue